import { useMemo } from 'react';

import { paths } from 'src/routes/paths';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  home: icon('ic_blank'),
  user: icon('ic_user'),
  shopping: icon('ic_ecommerce'), // Usando ic_ecommerce como ícone para shopping
  clientAdmins: icon('ic_user'), // Usando ic_user também para administradores de clientes
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      {
        subheader: 'Menu',
        items: [
          {
            title: 'Home',
            path: paths.backoffice.home,
            icon: ICONS.home,
          },
          {
            title: 'Administradores',
            path: paths.backoffice.admin.list,
            icon: ICONS.user,
          },
          {
            title: 'Shoppings',
            path: paths.backoffice.shopping.list,
            icon: ICONS.shopping,
          },
          {
            title: 'Admins do Shopping',
            path: paths.backoffice.clientAdmins.selectClient,
            icon: ICONS.clientAdmins,
          },
        ],
      },
    ],
    []
  );

  return data;
}
